export default __webpack_public_path__ + "static/media/roadmap-m-2.9d8acbc0.png";